import { LeaderboardService } from "@/common/api/Services/Leaderboard";
export const leaderboardActions = {
    getLeaderboard: async (params, dispatch) => {
        dispatch({ type: "LOADING_LEADERBOARD" });
        try {
            let data = await LeaderboardService.getLeaderboard(params);
            dispatch({
                type: "GET_LEADERBOARD",
                payload: data,
                params: params,
            });
        }
        catch (error) {
            dispatch({ type: "ERROR_LEADERBOARD" });
            console.error(error);
        }
    },
    loadMoreLeaderboardEnd: async (params, dispatch) => {
        try {
            let data = await LeaderboardService.getLeaderboard(params);
            dispatch({
                type: "UPDATE_LEADERBOARD_END",
                payload: data,
            });
        }
        catch (error) {
            console.error(error);
        }
    },
    loadMoreLeaderboardStart: async (params, dispatch) => {
        try {
            let data = await LeaderboardService.getLeaderboard(params);
            dispatch({
                type: "UPDATE_LEADERBOARD_START",
                payload: data,
            });
        }
        catch (error) {
            console.error(error);
        }
    },
    getTeamParticipants: async (params, dispatch) => {
        try {
            let data = await LeaderboardService.getLeaderboardLookup(params);
            dispatch({
                type: "GET_LEADERBOARD_LOOKUP",
                payload: data,
                params: params,
            });
        }
        catch (error) {
            console.error(error);
        }
    },
    loadMoreTeamParticipantsEnd: async (params, dispatch) => {
        try {
            let data = await LeaderboardService.getLeaderboardLookup(params);
            dispatch({
                type: "UPDATE_LEADERBOARD_LOOKUP_END",
                payload: data,
                params: params,
            });
        }
        catch (error) {
            console.error(error);
        }
    },
    loadMoreTeamParticipantsStart: async (params, dispatch) => {
        try {
            let data = await LeaderboardService.getLeaderboardLookup(params);
            dispatch({
                type: "UPDATE_LEADERBOARD_LOOKUP_START",
                payload: data,
                params: params,
            });
        }
        catch (error) {
            console.error(error);
        }
    },
};
